module.exports = __webpack_public_path__ + "img/2024-womens-retreat.6a16a6ca.jpg";